var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading_view",on:{"touchmove":function($event){$event.preventDefault();}}},[_c('van-loading',{attrs:{"color":"#fff"}},[_vm._v("加载中...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }